import { render, staticRenderFns } from "./VueComment.vue?vue&type=template&id=2a4c65a4&"
import script from "./VueComment.vue?vue&type=script&lang=js&"
export * from "./VueComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports